/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Control } from 'react-hook-form';
import { Icons } from '../../../../../Shared/Constants/Icons';
import { BoxShadow } from '../../../../../Shared/Constants/Style.Constants';
import { allMonthsOptions } from '../../AllSchedules/AllSchedules.Model';
import { Options } from '../../../../../Shared/Components/Common/Dropdown/Dropdown.styles';
import DaySelectionGrid from '../../AllSchedules/ModifySchedule/DaySelectionGrid';
import { Labels } from '../../../../../Shared/Components/Common/GraphContainer/GraphContainer';
import { Styles } from './CreateSchedules.Style';
import { buttonStyles } from '../../../../Jobs/Components/AddEditOneTimeJob/AddEditOneTimeJob.Style';

const MonthDaySelector: React.FC<{
  t?: (key: string) => string;
  control?: Control<any>;
  monthValue: string;
  setMonthValue: (val: string) => void;
  dayName: string;
  setDayValue: (val: string) => void;
  isMonthOpen?: boolean;
  setIsMonthOpen?: (val: boolean) => void;
  showLabel?: boolean;
}> = ({ t, control, monthValue, setMonthValue, dayName, setDayValue, isMonthOpen, setIsMonthOpen, showLabel }) => {
  const { marginBottom } = Styles;
  const { textField } = buttonStyles;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: showLabel ? '0.75rem 0' : '0',
        ...marginBottom,
      }}>
      <Box>
        <TextField
          select
          sx={{ ...textField, marginBottom: '2rem' }}
          label={
            <span>
              {t?.('jobManagement:month')} <span className="mandatory-field">*</span>
            </span>
          }
          value={monthValue}
          onChange={(e) => setMonthValue(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setIsMonthOpen?.(!isMonthOpen)} style={{ padding: 0 }}>
                  <img
                    src={isMonthOpen ? Icons.DropdownDownIcon : Icons.DropdownUpIcon}
                    alt={t?.(Labels.TextDropDown)}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
          SelectProps={{
            open: isMonthOpen,
            IconComponent: () => null,
            onOpen: () => setIsMonthOpen?.(true),
            onClose: () => setIsMonthOpen?.(false),
            MenuProps: {
              PaperProps: {
                style: {
                  boxShadow: BoxShadow.BoxShadow,
                },
              },
            },
          }}>
          {allMonthsOptions.map((month) => (
            <Options key={month.value} value={month.value}>
              {month.label}
            </Options>
          ))}
        </TextField>
      </Box>

      <DaySelectionGrid control={control} name={dayName} isScheduleCreation={true} setSelectedDate={setDayValue} />
    </Box>
  );
};

export default MonthDaySelector;
